import React from "react";
import type { IconProps } from "./types";

/**
 * ArrowLeftIcon component that renders a left-pointing chevron, used for
 * back navigation
 * @param props - The component props
 * @param props.className - CSS class name for styling
 * @param props.width - Width of the icon (default: 15)
 * @param props.height - Height of the icon (default: 15)
 * @param props.strokeWidth - Stroke width of the icon (default: 0.63)
 * @returns The rendered arrow left icon component
 */
const ArrowLeftIcon: React.FC<IconProps> = ({ className, width = 15, height = 15, strokeWidth = 0.63 }) => {
  return (
    <svg
      viewBox="-0.315 -0.315 15 15"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
    >
      <desc>Arrow Left 1 Streamline Icon: https://streamlinehq.com</desc>
      <path
        d="M11.017 0.299375 3.48771875 6.9610674999999995a0.299375 0.299375 0 0 0 0 0.447865L11.017 14.070625"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export default ArrowLeftIcon;
